// Copyright (c) 2021, DIALPAD INC., all rights reserved.

import React from 'react';
import {get} from 'lodash';
import {NPSAnswer} from './nps';
import {CESAnswer} from './ces';
import {CSATAnswer} from './csat';

interface CXAnswerProps {
    message: any;
}

// Delegates which CX component will be rendered.
export const CXAnswer = (props: CXAnswerProps) => {
    const {message} = props;
    const type = get(message, 'aspect');

    switch (type) {
        case 'nps':
            return <NPSAnswer message={message} />;
        case 'ces':
            return <CESAnswer message={message} />;
        case 'csat':
            return <CSATAnswer message={message} />;
    }
};
